import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { lifecycle, nest, compose } from 'recompose'
import T from 'i18n-react'

import Header from './Header'
import Divider from 'components/fulcrum/divider/Divider'
import FileList from 'components/project/projectView/nvqualFileSection/index'
import Title from './Title'

import {
  fetchFile,
  fetchFileForPreview
} from 'containers/Project/FileSection/actions'

import { 
  updatePreviewShow 
} from 'containers/Project/FilePreview/actions'

import {
  filesSelector
} from './selectors'

const mapStateToProps = (state) => {
  return {
    files: filesSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onDownload: (id, name) => dispatch(fetchFile(id, name)),
    openPreview: () => dispatch(updatePreviewShow(true)),
    fetchFileForPreview: (id, name) => dispatch(fetchFileForPreview(id, name)),
  }
}

class FileSection extends Component {

  onPreview(id, name){
    this.props.fetchFileForPreview(id, name)
    this.props.openPreview()
  }

  render(){
    const {
      files,
      onDownload,
    } = this.props

    return (
      <div>
        <Divider/>
        <Title>
          { T.translate('containers.project.nvqualFile.index.header') }
        </Title>
        {
          files.length > 0
            ? <Header/>
            : null
        }
        <FileList
          onDownload={onDownload}
          onPreview={(id, name) => {this.onPreview(id, name)}}
          files={files}
        />
      </div>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
  withConnect,
)

export default enhance(FileSection)
